import { Box, Grid, LinearProgress, Typography } from '@mui/material'
import CardTitle from './cardTitle';
import ClickableCard from '../../common/clickableCard';
import SkeletonCard from '../../common/skeletonCard';
import custom from '../../../styles/mui/szVariables.json'

export default function DashboardUsageCard({ 
        id, color, content, handleCardClick }: any) {
    const linebar = content?.unit === '%';
    if(!content) return (
        <SkeletonCard height="144px" />
    )
    return (
        <ClickableCard
                id={id}
                height="144px"
                px={custom.spacing.sm}
                py={custom.spacing.sm}
                handleCardClick={ ()=>handleCardClick(id)}
            >
            <Grid container direction="column" 
                    justifyContent="flex-start" 
                    width="100%">
                <Grid item>
                    <CardTitle icon={content?.icon} 
                                cardTitle={content.cardTitle} 
                                hoverIcon={content.hoverIcon} 
                                id={id} />
                </Grid>
                <Grid item pt={
                        linebar?custom.spacing.sm: custom.spacing.xl
                    }>
                    <Typography variant='szHeading.Bold.Large'
                            id={id+'Value'}>
                        {content.value}
                        <Typography 
                            variant="szHeading.Regular.Small" >
                            {content.unit}
                        </Typography>
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography sx={{ color: 'text.primary'}}
                        variant="szBody.Regular.Small" >
                        {content.desc}
                    </Typography>     
                </Grid>
                <Grid item pt={custom.spacing.xs} 
                    display={linebar?'flex':'none'}
                    width={"100%"}>
                    <Box width="100%" id="progressBar">
                        <LinearProgress variant="determinate" 
                            value={linebar?content.value:0} 
                            color={color}
                            sx={{
                                height: '14px',
                                borderRadius: custom.corners2,
                                backgroundColor: 'sz.colors.surfaceWellSmall'
                            }}/>   
                    </Box>
                </Grid>
            </Grid>  
        </ClickableCard>
    )
}